// extracted by mini-css-extract-plugin
export default {"modalBody":"styles_modalBody__ZzHWJ","modalInput":"styles_modalInput__GCTrw"};